import { useIsMountedInterface } from './types'
import { useEffect, useRef } from 'react'

export const useIsMounted: useIsMountedInterface = () => {
	const ref = useRef(false)

	useEffect(() => {
		ref.current = true
		return () => {
			ref.current = false
		}
	}, [])

	return ref.current
}
